/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export interface ICreatePdfActionBlockDocumentationScope extends ng.IScope {
        workflowBlock: models.CreatePdfWorkflowBlock,
        pdfBindings: Wars.Domain.Model.PdfBinding[]
        pdfBinding: Wars.Domain.Model.PdfBinding
    }

    export class CreatePdfActionBlockDocumentation implements IDirective {
        public controller = ['$scope', CreatePdfActionBlockDocumentationController];
        public controllerAs = 'controller';
        public templateUrl = './app/views/directives/documentation/createPdfActionBlock.html';
        public restrict: string = "E";

        public scope: any = {
            workflowBlock: '=',
            pdfBindings: '=',
        };

        public link(scope: ICreatePdfActionBlockDocumentationScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, controller: CreatePdfActionBlockDocumentationController): void {
        }
    }

    export class CreatePdfActionBlockDocumentationController implements IController {
        private $scope: ICreatePdfActionBlockDocumentationScope;

        constructor($scope: ICreatePdfActionBlockDocumentationScope) {
            this.$scope = $scope;
        }
    }
}

warsApp.registerDirective('CreatePdfActionBlockDocumentation', []);